import { useScrollChromeVisibility } from "../../hooks/useScrollChromeVisibility";
import AmbientBackground from "./AmbientBackground";
import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";

type Props = {
  readonly children: React.ReactNode;
};

export default function Layout({ children }: Props) {
  const chromeVisible = useScrollChromeVisibility();

  return (
    <div className="relative flex min-h-dvh flex-col">
      <AmbientBackground />

      <SiteHeader visible={chromeVisible} />

      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-surface focus:px-3 focus:py-2 focus:text-sm focus:text-foreground focus:shadow-lg focus:ring-2 focus:ring-ring"
      >
        Skip to content
      </a>

      <main
        id="main"
        className="relative z-10 mx-auto w-full max-w-6xl flex-1 overflow-x-hidden px-4 pb-24 pt-24 md:px-6"
      >
        {children}
      </main>

      <SiteFooter visible={chromeVisible} />
    </div>
  );
}
